import { useCallback } from 'react';
import { Box, Divider, Stack, ToggleButton, Tooltip } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuButtonUnderline,
  MenuButtonBulletedList,
  MenuSelectTextAlign,
  useRichTextEditorContext,
} from 'mui-tiptap';

const groupSx = {
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
  '& .MuiToggleButton-root': {
    width: 40,
    height: 40,
    border: 0,
    borderRadius: 0,
    '&.Mui-selected': {
      bgcolor: 'action.selected',
      borderRadius: 0,
      '& .MuiSvgIcon-root': {
        color: 'text.primary',
      },
    },
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.5rem',
  },
};

interface RichTextToolbarProps {
  showLinkButton?: boolean;
}

export function RichTextToolbar({ showLinkButton = false }: RichTextToolbarProps) {
  const editor = useRichTextEditorContext();

  const handleLink = useCallback(() => {
    if (!editor) return;

    if (editor.isActive('link')) {
      editor.chain().focus().unsetLink().run();
      return;
    }

    const url = window.prompt('Enter URL:');
    if (url) {
      editor.chain().focus().setLink({ href: url }).run();
    }
  }, [editor]);

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 1.5, p: 2 }}>
        <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} sx={groupSx}>
          <MenuButtonBold />
          <MenuButtonItalic />
          <MenuButtonUnderline />
          <MenuSelectTextAlign />
        </Stack>
        <Stack direction="row" sx={groupSx}>
          <MenuButtonBulletedList />
        </Stack>
        {showLinkButton && (
          <Stack direction="row" sx={groupSx}>
            <Tooltip title="Insert link">
              <ToggleButton
                value="link"
                selected={editor?.isActive('link') ?? false}
                onClick={handleLink}
                size="small"
              >
                <LinkIcon />
              </ToggleButton>
            </Tooltip>
          </Stack>
        )}
      </Box>
      <Divider sx={{ mx: 2 }} />
    </Box>
  );
}

export default RichTextToolbar;
